module.exports = __webpack_public_path__ + "img/reserve.e6eef358.png";